export default __webpack_public_path__ + "static/media/Facebook_logo.db4e30e5.svg";